import { Component, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PlayerService } from 'src/app/services';
import { RoutingService } from 'src/app/services/routing-service';
declare var $: any;

@Component(
    {
        selector: 'app-overlay-menu',
        templateUrl: 'overlay-menu.component.html',
        styleUrls: [
            'overlay-menu.component.scss'
        ]
    }
)
export class OverlayMenuComponent implements OnInit, OnDestroy
{
    @Output('closed')
    public closed = new EventEmitter();

    @Output('opened')
    public opened = new EventEmitter();

    public isAuthorized = false;

    private router: Router;
    private routeChangedSubscription: Subscription;
    private playerService: PlayerService;
    private playerIsAuthorizedSubscription: Subscription;
    private routingService: RoutingService;

    @HostListener('document:keydown.escape', ['$event'])
    public onKeydownHandler(event: Event): void
    {
        this.close();
    }

    public constructor(
        router: Router,
        playerService: PlayerService,
        routingService: RoutingService)
    {
        this.router = router;
        this.playerService = playerService;
        this.routingService = routingService;
    }

    public open(): void
    {
        if (typeof $ !== 'undefined')
        {
            $('.overlay').addClass('open');
            $('.overlay-back, .overlay-bg').addClass('open');
            this.opened.emit();
        }
    }

    public close(): void
    {
        if (typeof $ !== 'undefined')
        {
            $('.overlay').removeClass('open');
            $('.overlay-back, .overlay-bg').removeClass('open');
            this.closed.emit();
        }
    }

    public menuItemClicked(): void
    {
        this.close();
    }

    public ngOnInit(): void
    {
        this.routeChangedSubscription = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)).
            subscribe(val =>
            {
                this.close();
            });

        this.playerIsAuthorizedSubscription = this.playerService.getAuthorizedObservable().subscribe((isAuthorized: boolean) => {
            if (isAuthorized)
            {
                this.isAuthorized = true;
            }
            else
            {
                this.isAuthorized = false;
            }
        });
    }

    public navigateToMyPage(): void
    {
        this.routingService.navigateMyPage();

        this.close();
    }

    public showPage(path: string): void
    {
      this.router.navigateByUrl(path);
    }

    public onSignOutClick(): void
    {
        this.close();
        this.playerService.requestSignout();
    }

    public ngOnDestroy(): void
    {
        if (!this.routeChangedSubscription.closed)
        {
            this.routeChangedSubscription.unsubscribe();
        }
        this.playerIsAuthorizedSubscription.unsubscribe();
    }
}


